import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary, ToastProvider, initAdConsent } from "@suite/ui";
import { App, STORAGE_KEY } from "./App.tsx";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root missing from index.html");

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary storageKey={STORAGE_KEY}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ErrorBoundary>
  </StrictMode>,
);

// Boots the Google-certified CMP. Ads stay off until it reports a "yes".
initAdConsent();
